<template>
  <SendNotifications />
  <ToastNotifications />
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
